import formattedAddress from '@helpers/address';
import React from 'react';

type Props = {
  address: string;
};

export default function MapMobile({ address }: Props) {
  return (
    <div
      id="map-section"
      data-testid="map-section"
      className="border-b-8 border-rp-gray-divider px-4 pb-12 mt-8 d:px-0"
    >
      <p className="font-rp-gelica-light leading-26px text-22 text-rp-primary-black">Location</p>
      <p className="-tracking-0.26 mt-6">{formattedAddress(address)}</p>
      <iframe
        data-testid="map"
        title="maps"
        className="h-96 mt-4 rounded-md w-full"
        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyC0LFF2RGCc0NyRE-mhrJ7ejiYssie35Gk
                                  &q=${formattedAddress(address)}`}
      />

      {/* <div className="mt-6">
        <ButtonSecondary onClick={() => null}>Show Nearby</ButtonSecondary>
      </div> */}
    </div>
  );
}
